import { orderBy, sortBy, unionBy, compact } from 'lodash';

export const isPerGb = (p) => p.plan_type === 'PerGB';
export const isUnlimited = (p) => p.plan_type === 'Unlimited';
export const isHidden = (p) => p.status === 'hidden';
export const isActive = (p) => p.status === 'active';
export const parsePrice = (p) => {
  p.parsedPrice = parseFloat(p.price);
  return p;
}

/*
 * filterUsablePlans() - get plans available for upgrade
 * adapted from https://github.com/WingTel/Wing-Android/blob/develop/app/src/main/java/wingfi/com/wing/utils/PlansUtility.kt
 */
export const filterUsablePlans = (allPlans, currentPlan, upcomingPlan) => {
  const carrier = currentPlan.carrier;

  let usablePlans = [];
  if (!allPlans || !currentPlan) {
    return usablePlans;
  }

  let regularPlans = allPlans.filter(p => isPerGb(p) && (p.data_available >= currentPlan.data_available));
  if (carrier === 'sprint') {
    regularPlans = regularPlans.filter(p => p.is_lte);
  }
  usablePlans = usablePlans.concat(regularPlans);

  // Get all eligible unlimited plans
  let unlimitedPlans = allPlans.filter(p => isUnlimited(p));
  if (carrier === 'bypassed') {
    unlimitedPlans = unlimitedPlans.filter(p => p.plan_code === 'ATT_WNG_Unlimited');
  }

  // Use hidden plans if possible, otherwise use active plans
  let hiddenUnlimitedPlans = unlimitedPlans.filter(p => isHidden(p));
  if (hiddenUnlimitedPlans.length > 0) {
    unlimitedPlans = hiddenUnlimitedPlans;
  }
  else {
    unlimitedPlans = unlimitedPlans.filter(p => isActive(p));
  }

  // The unlimited plan we want is the cheapest with the most data
  // Have to parse the price because it comes out of the DB as a string
  unlimitedPlans = orderBy(
    unlimitedPlans.map(p => parsePrice(p)),
    ['parsedPrice', 'data_available'],
    ['asc', 'desc']
  );
  const bestUnlimitedPlan = unlimitedPlans[0];
  if (bestUnlimitedPlan) {
    usablePlans.push(bestUnlimitedPlan);
  }

  // Add current and upcoming plans, if they were passed in and if they aren't already there
  let inUsePlans = compact([currentPlan, upcomingPlan]);
  usablePlans = unionBy(inUsePlans, usablePlans, 'id');

  // Sort the plans and let's get outta here
  return sortBy(usablePlans, 'data_available').map(p => parsePrice(p)).filter(p => p.data_available >= currentPlan.data_available);
}

